import { Box } from '@mui/material';
import React, { useContext, useState } from 'react';
import {
    DeleteButton,
    SaveButton, Toolbar,
    Confirm,
    useRecordContext,
    useDelete
} from 'react-admin';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';

export const EditToolbar = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return (
        <Toolbar {...props}>
            <Box display="flex" justifyContent="space-between" width={1}>
                <SaveButton />
                <DeleteButton disabled={readonly} mutationMode="pessimistic"/>
            </Box>
        </Toolbar>
    );
};
